import { Localization } from "@viamap/viamap2-common";
import {
   aiFieldTone,
   formatAiFieldStatus,
   formatPageFindStatus,
   formatProvenanceChip,
   provenanceChipTone,
   type ANNServitutProvenance,
   type ServitutAiFieldStatus,
   type ServitutPageFindStatus,
} from "src/modules/ANNModule/ANNServitutProvenance";

export function ServitutMarkChip(props: {
   text: string;
   tone?: "ok" | "warn" | "bad" | "neutral";
   title?: string;
}) {
   if (!props.text) {
      return null;
   }
   return (
      <span
         className={`servitut-redegoerelse__markChip servitut-redegoerelse__markChip--${props.tone || "neutral"}`}
         title={props.title || props.text}
      >
         {props.text}
      </span>
   );
}

export function ServitutProvenanceChip(props: { provenance?: ANNServitutProvenance }) {
   const text = formatProvenanceChip(props.provenance);
   if (!text) {
      return <ServitutMarkChip text={Localization.getText("No source mark")} tone="neutral" />;
   }
   return <ServitutMarkChip text={text} tone={provenanceChipTone(props.provenance)} />;
}

export function ServitutPageFindChip(props: { status: ServitutPageFindStatus }) {
   return (
      <ServitutMarkChip
         text={formatPageFindStatus(props.status)}
         tone={props.status === "found" ? "ok" : props.status === "none" ? "bad" : "neutral"}
      />
   );
}

export function ServitutAiFieldChip(props: { status?: ServitutAiFieldStatus }) {
   return (
      <ServitutMarkChip
         text={formatAiFieldStatus(props.status)}
         tone={aiFieldTone(props.status)}
      />
   );
}
